import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { ACTIONS, API_URL, STORAGE } from "src/_config";
import { getSSOCookie } from "src/_common/utils/ssoCookie";

export function SSOHandler() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state: any) => state.user?.isAuthenticated);
  const attempted = useRef(false);

  const runSsoCheck = () => {
    const localToken = localStorage.getItem(STORAGE);
    if (localToken) return;
    const ssoToken = getSSOCookie();
    if (!ssoToken) return;
    axios({
      method: "GET",
      url: API_URL.AUTH.DETAILS,
      headers: { Authorization: `Bearer ${ssoToken}` },
    })
      .then((res) => {
        const user = res.data.data.user;
        localStorage.setItem(STORAGE, ssoToken);
        dispatch({ type: ACTIONS.AUTH.LOGIN, payload: { user, token: ssoToken } });
      })
      .catch((err: any) => { console.warn("[SSO] Token validation failed:", err?.response?.status, err?.message); });
  };

  // On mount: try SSO if not already authenticated
  useEffect(() => {
    const localToken = localStorage.getItem(STORAGE);
    if ((!isAuthenticated || !localToken) && !attempted.current) {
      attempted.current = true;
      runSsoCheck();
    }
  }, []);

  // On tab focus: pick up login/logout that happened in another site's tab
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        const localToken = localStorage.getItem(STORAGE);
        const ssoToken = getSSOCookie();
        // Auto-logout: logged in here but SSO cookie was cleared on the other site
        if (localToken && !ssoToken) {
          localStorage.removeItem(STORAGE);
          dispatch({ type: ACTIONS.AUTH.LOGOUT });
          return;
        }
        runSsoCheck();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  return null;
}
